var exports = {
  "k": "x2b2fbebb--193ca0--container",
};

module.exports = exports;
